import {ClientsActions, ClientsState, OrganizationClient} from "types/store";
const originalFilters = {
  Assignee: [],
};
const updatedFilters = {
  Assignee: [],
};

const initialState: ClientsState = {
  selectedOrganizationsRows: [],
  showbulkActionsClients: false,
  page: {
    selectedPage: 1,
    totalElements: 0,
    totalPages: 0,
  },
  filters: {
    original: originalFilters,
    updated: updatedFilters,
    listType: "current",
  },
  search: "",
  setSelectedTab: "B2B clients"
};

export default function clientReducer(
  state: ClientsState = initialState,
  action: ClientsActions
): ClientsState {
  switch (action.type) {
    case "SET_CLIENT_BULK_ACTIONS":
      return { ...state, showbulkActionsClients: action.payload };
    case "SET_CLIENTS":
      return {...state, organizations: action.payload};
    case "SET_SELECTED_ORGANIZATION":
      return {...state, selectedOrganization: action.payload};
    case "SET_SELECTED_TAB":
      return {...state, setSelectedTab: action.payload};
    case "SET_CLIENT_SEARCH":
      return {
        ...state,
        search: action.payload,
      };
    case "SET_SELECTED_ORGANIZATION_ROWS":
      return {...state, selectedOrganizationsRows: action.payload}
    case "SET_CLIENT_LIST_TYPE":
      return {
        ...state,
        filters: {
          ...state.filters,
          listType: action.payload,
        },
      };
    default:
      return state;
  }
}
